import React from "react";
import { Button, Dropdown, DropdownProps, MenuProps, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { ExcelIcon } from "../assets/icons/ExcelIcon";
import { CsvIcon } from "../assets/icons/CsvIcon";

type MenuItem = Required<MenuProps>["items"][number];

const functionStyles: DropdownProps["styles"] = (info) => {
  const { props } = info;
  const isClick = props.trigger?.includes("click");
  if (isClick) {
    return {
      root: {
        borderColor: "#1890ff",
        borderRadius: "8px",
      },
    } satisfies DropdownProps["styles"];
  }
  return {};
};

const ExportPage: React.FC<any> = ({ onExport }) => {
  const items: MenuItem[] = [
    {
      key: "sub1",
      icon: <span style={{ display: "inline-flex", alignItems: "center" }}><CsvIcon /></span>,
      label: "CSV",
      onClick: () => onExport?.("CSV", "ALL")
    },
    {
      key: "sub2",
      icon: <span style={{ display: "inline-flex", alignItems: "center" }}><ExcelIcon /></span>,
      label: "EXCEL",
      onClick: () => onExport?.("EXCEL", "ALL")
    },
  ];

  return (
    <Dropdown
      menu={{ items }}
      placement="bottomLeft"
      styles={functionStyles}
      trigger={["click"]}
    >
      <Button type="primary" style={{borderRadius: 10}}>
        <Space>
          Export
          <FontAwesomeIcon icon={faAngleDown} />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default ExportPage;
